<template>
  <div
    class="loading-container grey lighten-5"
    data-test="loadingContainer"
    :class="dialog && 'dialog'"
  >
    <div class="d-flex flex-column align-center">
      <VProgressCircular
        :size="size"
        color="brandingPrimary"
        indeterminate
      />
      <h5
        v-if="label"
        class="heading-5 brandingPrimary--text"
      >
        {{ $t(label) }}
      </h5>
    </div>
  </div>
</template>
<script lang="ts">
export default {
  name: 'Spinner',
};
</script>

<script setup lang="ts">
defineProps({
  size: {
    type: String,
    default: '50',
  },
  width: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: null,
  },
  dialog: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped lang="scss">
.loading-container{
  position: absolute;
  display: flex;
  z-index: 99;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  opacity: 0.46;

  &.dialog {
    top: 0%;
    left: 0%;
  }
}
</style>
